import { Button, Modal, PasswordInput, Text } from "@mantine/core";
import { IconDeviceFloppy } from "@tabler/icons-react";
import { type FormEvent, memo, useCallback, useEffect, useState } from "react";
import {
  ButtonRow,
  FormsContainer,
  Row,
  RowsContainer,
} from "src/generator/_Modals/AuthorizationModal/AuthorizationModal.styled";
import { refreshLogoutTimer } from "src/generator/utils/refreshLogoutTimer";
import { usePostApi } from "src/hooks";
import { SmallDivider } from "src/styled";

interface IAuthLogbookModal {
  opened: boolean;
  close: () => void;
  lbid?: string;
  onSuccess: (token: string) => void;
  report?: boolean;
}

const AuthLogbookModal = ({
  opened,
  close,
  lbid,
  onSuccess,
  report,
}: IAuthLogbookModal) => {
  const { post, isLoading } = usePostApi();
  const [password, setPassword] = useState("");

  useEffect(() => {
    setPassword("");
  }, [opened]);

  const handleSubmit = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      const request = report
        ? "auth-logbook-access-report"
        : "auth-logbook-access";
      const params: Record<string, string> = { password };
      if (!report) params.lbid = lbid as string;
      await post({
        request,
        body: { params },
        onSuccess: data => {
          onSuccess(data.token);
          refreshLogoutTimer();
        },
      });
    },
    [report, password, lbid, post, onSuccess],
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  return (
    <Modal
      size="50%"
      opened={opened}
      zIndex={11}
      onClose={close}
      withCloseButton={false}>
      <Text>Authorization is required!</Text>
      <SmallDivider />
      <form onSubmit={handleSubmit}>
        <FormsContainer>
          <RowsContainer>
            <Row>
              <Text>Password</Text>
              <PasswordInput
                w={"70%"}
                placeholder="Password"
                name="pass"
                value={password}
                onChange={handleChange}
              />
            </Row>
          </RowsContainer>

          <ButtonRow>
            <Button
              loading={isLoading}
              type="submit"
              leftIcon={<IconDeviceFloppy size={"1rem"} />}
              disabled={password.length === 0}
              ml={5}>
              Submit
            </Button>
          </ButtonRow>
        </FormsContainer>
      </form>
    </Modal>
  );
};

export default memo(AuthLogbookModal);
